console.log("Posts Route FIle Loaded")
import AdminLayout from "../../layouts/AdminLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import axios from "axios";
import Loading from "../../layouts/Loading";
import Swal from "sweetalert2";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import DraggablePost from "./DraggablePost";

function PostsData({
  postsData,
  currentPage,
  itemsPerPage,
  handleDelete,
  handleEdit,
  handleToggleActive,
  handleToggleNewMod,
  handleCreatorChange,
  updateDiscount, // ✅ added
  onDragEnd,
  creators,
  newCreator,
  setNewCreator,
  handleAddCreator,
}) {
  const startIndex = (currentPage - 1) * itemsPerPage;
  const postsToDisplay = postsData.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="container mx-auto p-4">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-2xl font-bold text-gray-100">Posts Management</h1>
        <form className="flex gap-2" onSubmit={handleAddCreator}>
          <input value={newCreator} onChange={(event) => setNewCreator(event.target.value)} maxLength={60} placeholder="New creator name" className="rounded border border-gray-600 bg-gray-800 px-3 py-2 text-white" />
          <button type="submit" className="rounded bg-violet-600 px-4 py-2 font-semibold text-white">Add creator</button>
        </form>
      </div>

      <div className="bg-white shadow-lg rounded-lg overflow-hidden">
        <div className="overflow-x-visible">
          <DragDropContext onDragEnd={onDragEnd}>
            <table className="min-w-full bg-gray-800">

                  <thead className="bg-gradient-to-r from-gray-800 to-gray-700 text-white">
                    <tr>
                      <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider w-20">Order</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider w-32">Picture</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider min-w-64">Title</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider w-32">Discount %</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider w-40">Category</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider w-32">Status</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider w-32">NEW MOD</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider w-40">Actions</th>
                    </tr>
                  </thead>

                  <Droppable droppableId="posts" direction="vertical">
                    {(provided) => (
                      <tbody
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className="bg-gray-800 divide-y divide-gray-700"
                      >
                        {postsToDisplay.map((post, idx) => (
                          <DraggablePost
                            key={post._id}
                            post={post}
                            index={idx}
                            handleDelete={handleDelete}
                            handleEdit={handleEdit}
                            handleToggleActive={handleToggleActive}
                            handleToggleNewMod={handleToggleNewMod}
                            handleCreatorChange={handleCreatorChange}
                            updateDiscount={updateDiscount}
                            creators={creators}
                          />
                        ))}
                        {provided.placeholder}
                      </tbody>
                    )}
                  </Droppable>
                </table>
          </DragDropContext>
        </div>
      </div>
    </div>
  );
}

function Posts() {
  const [bulkStartOrder, setBulkStartOrder] = useState("");
  const [bulkEndOrder, setBulkEndOrder] = useState("");

  const [bulkDiscount, setBulkDiscount] = useState("");
  const [bulkLoading, setBulkLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 300;

  const [postsData, setPostsData] = useState([]);
  const [creators, setCreators] = useState([]);
  const [newCreator, setNewCreator] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const [loading, setLoading] = useState(true);
  const [isLoggedIn] = useState(true);

  useEffect(() => {
    fetchPosts();
    fetchCreators();
  }, []);

  const fetchCreators = async () => {
    try {
      const response = await axios.get("https://craftifyproductions.com/api/posts/creators");
      setCreators(response.data || []);
    } catch (error) {
      console.error("Error fetching creators:", error);
    }
  };

  const handleAddCreator = async (event) => {
    event.preventDefault();
    const name = newCreator.trim();
    if (!name) return;
    try {
      const response = await axios.post("https://craftifyproductions.com/api/posts/creators", { name });
      setCreators((previous) => [...previous, response.data]);
      setNewCreator("");
      Swal.fire("Creator added", name + " is now available in creator dropdowns.", "success");
    } catch (error) {
      Swal.fire("Error", error.response?.data?.error || "Unable to add creator.", "error");
    }
  };

  // Fetch all posts
  const fetchPosts = async () => {
    try {
      const response = await axios.get("https://craftifyproductions.com/api/posts/admin/all");
      setPostsData(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching posts:", error);
      setLoading(false);
    }
  };

  // Creator update handler
  const handleCreatorChange = async (postId, creator) => {
  try {
    await axios.put(
      `https://craftifyproductions.com/api/posts/${postId}`,
      { creator }
    );

    setPostsData(prev =>
      prev.map(p =>
        p._id === postId ? { ...p, creator } : p
      )
    );
  } catch (error) {
    Swal.fire("Error!", "Unable to update creator.", "error");
  }
};


 const applyBulkDiscount = async () => {
  if (!bulkStartOrder || !bulkEndOrder || !bulkDiscount) {
    Swal.fire("Error", "Fill all fields", "error");
    return;
  }

  try {
    setBulkLoading(true);

    const res = await axios.put(
  "https://craftifyproductions.com/api/posts/bulk/discount",
  {
    startOrder: Number(bulkStartOrder),
    endOrder: Number(bulkEndOrder),
    discount: Number(bulkDiscount),
  }
);


    Swal.fire(
      "Success",
      `Updated ${res.data.modified} posts`,
      "success"
    );

    fetchPosts();
    setBulkStartOrder("");
    setBulkEndOrder("");
    setBulkDiscount("");
  } catch (err) {
    console.error(err);
    Swal.fire("Error", "Bulk update failed", "error");
  } finally {
    setBulkLoading(false);
  }
};


// ✅ FIXED discount updater
const updateDiscount = async (postId, newDiscount) => {
  console.log("Updating discount:", postId, newDiscount);

  try {
    const res = await axios.put(
      `https://craftifyproductions.com/api/posts/${postId}`, // ✅ PROD API
      { discount: Number(newDiscount) }
    );


    console.log("Backend response:", res.data);
    fetchPosts();
  } catch (err) {
    console.error("Failed to update discount", err);
  }
};

  // Delete post
  const handleDelete = async (postId) => {
    try {
      await axios.delete(`https://craftifyproductions.com/api/posts/${postId}`);
      Swal.fire("Deleted!", "Your post has been deleted.", "success");
      fetchPosts();
    } catch (error) {
      Swal.fire("Error!", "Unable to delete post.", "error");
    }
  };

  // Toggle Active
const handleToggleActive = async (postId, currentStatus) => {
  try {
    await axios.put(
      `https://craftifyproductions.com/api/posts/${postId}`,
      { isActive: !currentStatus }
    );

    setPostsData(prev =>
      prev.map(p =>
        p._id === postId
          ? { ...p, isActive: !currentStatus }
          : p
      )
    );
  } catch (error) {
    Swal.fire("Error!", "Unable to update post status.", "error");
  }
};

  // Toggle NEW MOD
const handleToggleNewMod = async (postId, currentStatus) => {
  try {
    await axios.put(
      `https://craftifyproductions.com/api/posts/${postId}`,
      { newModBanner: !currentStatus }
    );

    setPostsData(prev =>
      prev.map(p =>
        p._id === postId
          ? { ...p, newModBanner: !currentStatus }
          : p
      )
    );
  } catch (error) {
    Swal.fire("Error!", "Unable to update NEW MOD banner.", "error");
  }
};

  const handleEdit = (post) => (
    <Link to={`/Admin/Post/Edit/${post._id}`}>Edit</Link>
  );

  if (!isLoggedIn) return <Navigate to="/login" />;

  // Search filter
  const filteredPosts = postsData.filter((post) =>
    post.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalPages = Math.ceil(filteredPosts.length / itemsPerPage);

  // Drag handler
  const onDragEnd = async (result) => {
    const { destination, source } = result;
    if (!destination || destination.droppableId !== source.droppableId) return;
    if (source.index === destination.index) return;

    const pageStart = (currentPage - 1) * itemsPerPage;
    const visiblePosts = filteredPosts.slice(pageStart, pageStart + itemsPerPage);
    if (!visiblePosts[source.index] || !visiblePosts[destination.index]) return;

    const reorderedVisible = Array.from(visiblePosts);
    const [moved] = reorderedVisible.splice(source.index, 1);
    reorderedVisible.splice(destination.index, 0, moved);

    const fullIndexById = new Map(postsData.map((post, index) => [String(post._id), index]));
    const reordered = Array.from(postsData);
    for (let index = 0; index < visiblePosts.length; index += 1) {
      const fullIndex = fullIndexById.get(String(visiblePosts[index]._id));
      if (fullIndex !== undefined) reordered[fullIndex] = reorderedVisible[index];
    }
    const orderedPosts = reordered.map((post, order) => ({ ...post, order }));

    try {
      await axios.post("https://craftifyproductions.com/api/order/update", {
        orderedPostIds: orderedPosts.map((post) => String(post._id)),
      });
      setPostsData(orderedPosts);
    } catch (error) {
      console.error("Order update failed:", error);
      Swal.fire("Error", error.response?.data?.error || "Unable to save the new item order.", "error");
    }
  };

  const PostsContent = (
  <div className="p-4">
    {loading ? (
      <Loading />
    ) : (
      <>
        {/* 🔥 BULK DISCOUNT PANEL */}
        {/* 🔥 BULK DISCOUNT PANEL (BY ORDER) */}
        <div className="mb-6 bg-gray-900 border border-gray-700 rounded-lg p-4">
          
          {/* PANEL HEADING */}
          <h2 className="text-lg font-semibold text-white mb-4">
            Discount Panel — Global Setter
          </h2>

          <div className="flex flex-wrap items-end gap-4">
            <div>
              <label className="block text-xs text-gray-400 mb-1">
                Start Index
              </label>
              <input
                type="number"
                min="0"
                value={bulkStartOrder}
                onChange={(e) => setBulkStartOrder(e.target.value)}
                className="w-24 px-2 py-1 rounded bg-gray-800 text-white border border-gray-600"
              />
            </div>

            <div>
              <label className="block text-xs text-gray-400 mb-1">
                End Index
              </label>
              <input
                type="number"
                min="0"
                value={bulkEndOrder}
                onChange={(e) => setBulkEndOrder(e.target.value)}
                className="w-24 px-2 py-1 rounded bg-gray-800 text-white border border-gray-600"
              />
            </div>

            <div>
              <label className="block text-xs text-gray-400 mb-1">
                Discount %
              </label>
              <input
                type="number"
                min="0"
                max="100"
                value={bulkDiscount}
                onChange={(e) => setBulkDiscount(e.target.value)}
                className="w-24 px-2 py-1 rounded bg-gray-800 text-white border border-gray-600"
              />
            </div>

            <button
              onClick={applyBulkDiscount}
              disabled={bulkLoading}
              className="h-9 px-4 rounded bg-green-600 hover:bg-green-700 text-white font-medium disabled:opacity-50"
            >
              {bulkLoading ? "Applying..." : "Apply Discount"}
            </button>
          </div>
        </div>


        {/* Header + Search */}
        <div className="flex justify-between mb-4">
          <Link
            to="/Admin/Post/New"
            className="bg-indigo-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-indigo-600"
          >
            <FontAwesomeIcon icon={faPlus} /> New Post
          </Link>

          <div className="flex items-center bg-white border rounded-lg shadow-md px-4 py-2">
            <FontAwesomeIcon icon={faSearch} className="text-indigo-500 mr-2" />
            <input
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="outline-none bg-transparent"
            />

            {searchQuery && (
              <FontAwesomeIcon
                icon={faTimes}
                onClick={() => setSearchQuery("")}
                className="text-gray-400 ml-2 cursor-pointer"
              />
            )}
          </div>
        </div>

        {/* Data Table */}
        <PostsData
          postsData={filteredPosts}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          handleToggleActive={handleToggleActive}
          handleToggleNewMod={handleToggleNewMod}
          handleCreatorChange={handleCreatorChange}
          updateDiscount={updateDiscount}
          onDragEnd={onDragEnd}
          creators={creators}
          newCreator={newCreator}
          setNewCreator={setNewCreator}
          handleAddCreator={handleAddCreator}
        />

        {/* Pagination */}
        <div className="flex justify-center mt-4">
          {totalPages > 1 && currentPage > 1 && (
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              className="mr-2 bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-400"
            >
              Previous
            </button>
          )}

          <span>
            Page {currentPage} of {totalPages}
          </span>

          {totalPages > 1 && currentPage < totalPages && (
            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              className="ml-2 bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-400"
            >
              Next
            </button>
          )}
        </div>
      </>
    )}
  </div>
);


  return <AdminLayout Content={PostsContent} />;
}

export default Posts;
